import { PropTypes } from 'prop-types'
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '10rem',
        border: '0 none !important'
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
    box: {
        border: '0 none !important',
    }
}));

export default function Modal_Hook({ body, isOpen, handleClose, isPaper }) {
    const classes = useStyles();
    // const [open, setOpen] = React.useState(false);

    // const handleOpen = () => {
    //     setOpen(true);
    // };

    // const handleClose = () => {
    //     setOpen(false);
    // };

    // useEffect(() => {
    //     if (isOpen) {
    //         setOpen(isOpen)
    //     }
    // }, [isOpen])

    //console.log('---isOpen:', isOpen)

    return (
        <div>
            {/* <button type="button" onClick={handleOpen}>
                react-transition-group
            </button> */}
            <Modal
                // ariaHideApp={false}
                // aria-labelledby="transition-modal-title"
                // aria-describedby="transition-modal-description"
                className={classes.modal}
                open={isOpen}
                // open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={isOpen}>

                    <div className={isPaper && classes.paper, classes.box}>
                        {/* <h2 id="transition-modal-title">Transition modal</h2>
            <p id="transition-modal-description">react-transition-group animates me.</p> */}
                        {body}
                    </div>

                </Fade>
            </Modal>
        </div>
    );
}
Modal_Hook.propTypes = {
    body: PropTypes.object,
    isOpen: PropTypes.bool,
    isPaper: PropTypes.bool,
    handleClose: PropTypes.func,
}